import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, LoadingController, AlertController, IonInput, Platform } from '@ionic/angular';
import { APIService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { CountryService } from '../../services/country.service';
import { CartService } from '../../services/cart.service';
import { Decimal } from 'decimal.js';
import { Capacitor } from '@capacitor/core';
import { CountryPickerPage } from './../../modals/country-picker/country-picker.page';
import { AddressPickerPage } from './../../modals/address-picker/address-picker.page';
import * as moment from 'moment';
import { StorageService } from '../../services/storage.service';
import { ConnectedAccountService } from '../../services/connected-account.service';
import { RegisterService } from '../../services/register.service';
import { UserService } from '../../services/user.service';
import { DateTimePickerPage } from './../../modals/date-time-picker/date-time-picker.page';
import { ObserverService } from '../../services/observer.service';
import { Network } from '@capacitor/network';

@Component({
    selector: 'app-cart-shipping',
    templateUrl: './cart-shipping.page.html',
    styleUrls: ['./cart-shipping.page.scss'],
})
export class CartShippingPage implements OnInit {

    @ViewChild('shipping_price_input', { static: false }) shipping_price_input: IonInput;

    online = false;
    country = null;
    subdivisions = null;
    cart = null;
    spinner = null;
    moment = moment;
    modal_css_class = '';
    date_modal_css_class = '';
    formatted_delivery_date = null;
    address_requires_subdivision = false;
    address_subdivision_label = "State / province / region / county";
    address_requires_postal_code = false;
    address_postal_code_label = "Postcode";
    add_to_shipping_addresses = false;

    shipping = {
        gift: false
    };

    // modal flags
    date_picker_modal_open = false;
    country_picker_modal_open = false;
    address_picker_modal_open = false;

    constructor(
        private apiService: APIService,
        private router: Router,
        private authService: AuthService,
        public modalController: ModalController,
        public alertController: AlertController,
        private loadingController: LoadingController,
        private countryService: CountryService,
        private cartService: CartService,
        private platform: Platform,
        private storageService: StorageService,
        private connectedAccountService: ConnectedAccountService,
        private registerService: RegisterService,
        private observerService: ObserverService,
        private userService: UserService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
            this.date_modal_css_class = 'backdrop';
        }

        this.platform.ready().then(async () => {
            let network_status = await Network.getStatus();
            this.online = network_status.connected;
        });

        this.cartService.get().then((cart) => {
            if(cart) {

                this.cart = cart;

                if(cart['shipping_address']) {

                    this.shipping['address_first_name'] = cart['shipping_address'].first_name;
                    this.shipping['address_last_name'] = cart['shipping_address'].last_name;
                    this.shipping['address_line_1'] = cart['shipping_address'].line_1;
                    this.shipping['address_locality'] = cart['shipping_address'].locality;
                    this.shipping['gift'] = cart['gift'];
                    this.shipping['price'] = cart['shipping'].price;

                    if(cart['shipping_address'].organisation_title) {
                        this.shipping['address_organisation_title'] = cart['shipping_address'].organisation_title;
                    }
                    if(cart['shipping_address'].line_2) {
                        this.shipping['address_line_2'] = cart['shipping_address'].line_2;
                    }
                    if(cart['shipping_address'].subdivision) {
                        this.shipping['address_subdivision'] = cart['shipping_address'].subdivision;
                    }
                    if(cart['shipping_address'].postal_code) {
                        this.shipping['address_postal_code'] = cart['shipping_address'].postal_code;
                    }

                    if(cart['shipping_address'].country_id) {
                        this.shipping['address_country_id'] = cart['shipping_address'].country_id;
                        this.loadCountry(cart['shipping_address'].country_id).then(() => {
                            this.countryChanged();
                        })
                        .catch(() => { });
                    }

                    if(cart['shipping_address'].mobile_phone_number) {
                        this.shipping['address_mobile_phone_number'] = cart['shipping_address'].mobile_phone_number;
                    }
                    if(cart['shipping_address'].courier_instructions) {
                        this.shipping['address_courier_instructions'] = cart['shipping_address'].courier_instructions;
                    }
                    if(cart['shipping_notification_email_address']) {
                        this.shipping['shipping_notification_email_address'] = cart['shipping_notification_email_address'];
                    }
                    if(cart['gift_message']) {
                        this.shipping['gift_message'] = cart['gift_message']
                    }

                    if(cart['delivery_date']) {
                        this.storageService.get("connected_account_id").then((connected_account_id) => {
                            if(connected_account_id) {
                                this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account: any) => {
                                    if(connected_account['user)id']) {
                                        this.userService.getUser(connected_account['user_id']).then((user: any) => {
                                            this.shipping['delivery_date'] = this.moment.utc(cart['delivery_date']).tz(user.timezone.code).toISOString(true);
                                            this.formatted_delivery_date = this.moment(this.shipping['delivery_date']).format("D MMM YYYY");
                                        });
                                    }
                                })
                                .catch(() => { });
                            }
                        })
                        .catch(() => { });
                    }

                }
                else {

                    // NOTE: use the register country as a default
                    this.storageService.get("register_id").then((register_id) => {
                        if(register_id) {
                            this.registerService.getRegister(register_id).then((register: any) => {
                                if(register.location['physical_address']) {
                                    this.shipping['address_country_id'] = register.location.physical_address.country.id
                                    this.loadCountry(register.location.physical_address.country.id).then(() => {
                                        this.countryChanged();
                                    })
                                    .catch(() => { });
                                }
                            })
                            .catch(() => { });
                        }
                    })
                    .catch(() => { });

                }
            }
        });

        this.observerService.subscribe('network_status_changed|cart_shipping_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("network_status_changed|cart_shipping_modal");
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.shipping_price_input) {
                this.shipping_price_input.setFocus();
            }
        }, 200);
    }

    loadCountry(country_id) {
        const promise = new Promise<void>((resolve, reject) => {
            this.country = null;
            this.subdivisions = null;
            this.countryService.getCountry(country_id).then((country: any) => {
                if(country) {
                    this.country = country;
                    if(country.subdivisions) {
                        this.subdivisions = country.subdivisions;
                    }
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
        return promise;
    }

    countryChanged(){
        
        if(this.shipping['address_country_id']) {

            // NOTE: united kingdom not required, address might not have postcode yet
            if(this.country.title == "Australia" || this.country.title == "Canada" || this.country.title == "Ireland" || this.country.title == "Japan" || this.country.title == "Mexico" || this.country.title == "New Zealand" || this.country.title == "United States") {
                this.address_requires_postal_code = true;
            }
            else {
                this.address_requires_postal_code = false;
            }

            if(this.subdivisions && this.subdivisions.length != 0) {
                this.address_requires_subdivision = true;
            }
            else {
                this.address_requires_subdivision = false;
            }

            if(this.country.title == "Australia") {
                this.address_subdivision_label = "State / territory";
            }
            else if(this.country.title == "Canada") {
                this.address_subdivision_label = "Province / territory";
                this.address_postal_code_label = "Postal code";
            }
            else if(this.country.title == "Ireland") {
                this.address_subdivision_label = "County";
            }
            else if(this.country.title == "Japan") {
                this.address_subdivision_label = "Prefecture";
            }
            else if(this.country.title == "Mexico") {
                this.address_subdivision_label = "State";
            }
            else if(this.country.title == "New Zealand") {
                this.address_subdivision_label = "Region";
            }
            else if(this.country.title == "Philippines") {
                this.address_postal_code_label = "ZIP";
            }
            else if(this.country.title == "South Africa") {
                this.address_subdivision_label = "Province";
            }
            else if(this.country.title == "United States") {
                this.address_subdivision_label = "State";
                this.address_postal_code_label = "ZIP";
            }
            else {
                this.address_subdivision_label = "State / province / region / county";
                this.address_postal_code_label = "Postcode";
            }

        }

    }

    close() {
        this.modalController.dismiss();
    }

    update() {
        this.presentSpinner("Adding shipping").then(async () => {

            let validated = true;
            let regex = /^-?\d*\.?\d*$/;
            let email_address_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(this.shipping['price'] == null || this.shipping['price'].toString().trim() === "") {
                this.presentAlert("Problem", "Missing shipping price", "Please enter a shipping price.");
                validated = false;
            }
            else if(this.shipping['price'] < 0) {
                this.presentAlert("Problem", "Invalid shipping price", "The shipping price cannot be below zero.");
                validated = false;
            }
            else if(!regex.test(String(this.shipping['price']).toLowerCase())) {
                this.presentAlert("Problem", "Invalid shipping price", "The shipping price must be a number.");
                validated = false;
            }
            else if(this.shipping['address_first_name'] == null || this.shipping['address_first_name'].trim() === "") {
                this.presentAlert("Problem", "Missing first name", "Please enter a first name.");
                validated = false;
            }
            else if(this.shipping['address_last_name'] == null || this.shipping['address_last_name'].trim() === "") {
                this.presentAlert("Problem", "Missing last name", "Please enter a last name.");
                validated = false;
            }
            else if(this.shipping['address_country_id'] == null || this.shipping['address_country_id'].trim() === "") {
                this.presentAlert("Problem", "Missing country", "Please select a country.");
                validated = false;
            }
            else {
                if(this.shipping['address_line_1'] == null || this.shipping['address_line_1'].trim() === "") {
                    this.presentAlert("Problem", "Missing line 1", "Please enter a Line 1.");
                    validated = false;
                }
                else if(this.shipping['address_locality'] == null || this.shipping['address_locality'].trim() === "") {
                    this.presentAlert("Problem", "Missing town / city", "Please enter a town / city.");
                    validated = false;
                }
                else if(this.address_requires_subdivision && (this.shipping['address_subdivision'] == null || this.shipping['address_subdivision'].trim() === "")) {
                    this.presentAlert("Problem", "Missing " + this.address_subdivision_label, "Please enter a " + this.address_subdivision_label + ".");
                    validated = false;
                }
                else if(this.address_requires_postal_code && (this.shipping['address_postal_code'] == null || this.shipping['address_postal_code'].trim() === "")) {
                    this.presentAlert("Problem", "Missing " + this.address_postal_code_label, "Please enter a " + this.address_postal_code_label + ".");
                    validated = false;
                }
                else if(this.shipping['address_mobile_phone_number'] == null || this.shipping['address_mobile_phone_number'].trim() === "") {
                    this.presentAlert("Problem", "Missing mobile phone number", "Please enter a mobile phone number.");
                    validated = false;
                }
                else {

                    await this.countryService.getCountrySubdivisions(this.shipping['address_country_id']).then((subdivisions: any) => {

                        if(subdivisions && subdivisions.length) {

                            let subdivision_found = false;

                            for (let i = 0; i < subdivisions.length; i++) {

                                let subdivision = subdivisions[i];

                                if(subdivision.title == this.shipping['address_subdivision']) {
                                    subdivision_found = true;
                                    this.shipping['address_subdivision'] = subdivision.title;
                                    break;
                                }
                                
                            }

                            if(!subdivision_found) {
                                this.presentAlert("Problem", "Invalid " + this.address_subdivision_label, "Please enter a valid " + this.address_subdivision_label + ".");
                                validated = false;
                            }

                        }
                    });
                }
            }

            if(this.shipping['address_courier_instructions'] && this.shipping['address_courier_instructions'].trim().length > 100) {
                this.presentAlert("Problem", "Courier instructions exceeds 100 characters", "Please shorten the courier instructions and try again.");
                validated = false;
            }

            if(this.shipping['shipping_notification_email_address'] && !email_address_regex.test(String(this.shipping['shipping_notification_email_address']).toLowerCase())) {
                this.presentAlert("Problem", "Invalid shipping notification email address", "");
                validated = false;
            }

            if(validated) {

                // ensure 2dp
                if(this.shipping['price']) {
                    this.shipping['price'] = Number(new Decimal(this.shipping['price']).toDecimalPlaces(2));
                }

                // clear gift message if not a gift
                if(this.shipping['gift'] == false){
                    this.shipping['gift_message'] = null;
                }

                if(this.shipping['delivery_date']) {
                    this.shipping['delivery_date'] = this.moment(this.shipping['delivery_date']).utc().toISOString();
                }

                this.cartService.updateShipping(this.shipping).then(async () => {

                    if(this.add_to_shipping_addresses) {

                        let params = {};
                        params['first_name'] = this.shipping['address_first_name'];
                        params['last_name'] = this.shipping['address_last_name'];
                        params['line_1'] = this.shipping['address_line_1'];
                        params['locality'] = this.shipping['address_locality'];
                        params['country_id'] = this.shipping['address_country_id'];
                        params['mobile_phone_number'] = this.shipping['address_mobile_phone_number'];

                        if(this.shipping['address_organisation_title']) {
                            params['organisation_title'] = this.shipping['address_organisation_title'];
                        }
                        if(this.shipping['address_line_2']) {
                            params['line_2'] = this.shipping['address_line_2'];
                        }
                        if(this.shipping['address_subdivision']) {
                            params['subdivision'] = this.shipping['address_subdivision'];
                        }
                        if(this.shipping['address_postal_code']) {
                            params['postal_code'] = this.shipping['address_postal_code'];
                        }
                        if(this.shipping['address_courier_instructions']) {
                            params['courier_instructions'] = this.shipping['address_courier_instructions'];
                        }

                        if(this.cart['organisation']) {
                            await this.addOrganisationShippingAddress(this.cart['organisation'].id, params).then(() => {}).catch(() => {});
                        }
                        else if(this.cart['person']) {
                            await this.addPersonShippingAddress(this.cart['person'].id, params).then(() => {}).catch(() => {});
                        }

                    }

                    await this.spinner.dismiss();
                    await this.modalController.dismiss();

                })
                .catch(() => {
                    this.spinner.dismiss();
                });

            }
            else {
                this.spinner.dismiss();
            }

        })
        .catch(() => {
            this.spinner.dismiss();
        });
    }

    addPersonShippingAddress(person_id, params) {
        return new Promise<void>((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.addPersonShippingAddress(person_id, params).then((shipping_address) => {
                    if(shipping_address) {
                        this.observerService.publish('person_shipping_address_added', shipping_address);
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error.status == 400) {
                        this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to add a person shipping address.");
                    } 
                    else if(error.status == 403) {
                        this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to add a person shipping address.");
                    } 
                    else if(error.status == 404 || error.status == 0) {
                        this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to add a person shipping address at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    addOrganisationShippingAddress(organisation_id, params) {
        return new Promise<void>((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.addOrganisationShippingAddress(organisation_id, params).then((shipping_address) => {
                    if(shipping_address) {
                        this.observerService.publish('organisation_shipping_address_added', shipping_address);
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error.status == 400) {
                        this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to add an organisation shipping address.");
                    } 
                    else if(error.status == 403) {
                        this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to add an organisation shipping address.");
                    } 
                    else if(error.status == 404 || error.status == 0) {
                        this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to add an organisation shipping address at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    removeShipping() {
        this.cartService.updateShipping('').then(() => {
            this.modalController.dismiss();
        });
    }

    async presentCountryPickerModal() {
        if(!this.country_picker_modal_open) {
            this.country_picker_modal_open = true;
            let existing_shipping_address_country_id = "";
            if(this.shipping['address_country_id']) {
                existing_shipping_address_country_id = this.shipping['address_country_id'];
            }
            const modal = await this.modalController.create({
                component: CountryPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    country_id: this.shipping['address_country_id']
                }
            });
            modal.onDidDismiss().then((data) => {
                this.country_picker_modal_open = false;
                if(data.data) {
                    if(data.data === "country_deleted") {
                        delete this.shipping['address_country_id'];
                        delete this.shipping['address_line_1'];
                        delete this.shipping['address_line_2'];
                        delete this.shipping['address_locality'];
                        delete this.shipping['address_subdivision'];
                        delete this.shipping['address_postal_code'];
                        this.country = null;
                    }
                    else {
                        if(data.data['country_id'] != existing_shipping_address_country_id) {
                            this.shipping['address_country_id'] = data.data['country_id'];
                            this.loadCountry(data.data['country_id']).then(() => {
                                this.countryChanged();
                            })
                            .catch(() => { });
                        }
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAddressPickerModal() {
        if(!this.address_picker_modal_open) {
            this.address_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: AddressPickerPage,
                cssClass: this.modal_css_class  + ' cart-shippping-address-book',
            });
            modal.onDidDismiss().then((data) => {
                this.address_picker_modal_open = false;
                if(data.data) {

                    if(data.data['first_name']) {
                        this.shipping['address_first_name'] = data.data['first_name'];
                    }
                    else {
                        delete this.shipping['address_first_name'];
                    }

                    if(data.data['last_name']) {
                        this.shipping['address_last_name'] = data.data['last_name'];
                    }
                    else {
                        delete this.shipping['address_last_name'];
                    }

                    if(data.data['organisation_title']) {
                        this.shipping['address_organisation_title'] = data.data['organisation_title'];
                    }
                    else {
                        delete this.shipping['address_organisation_title'];
                    }

                    if(data.data['line_1']) {
                        this.shipping['address_line_1'] = data.data['line_1'];
                    }
                    else {
                        delete this.shipping['address_line_1'];
                    }

                    if(data.data['line_2']) {
                        this.shipping['address_line_2'] = data.data['line_2'];
                    }
                    else {
                        delete this.shipping['address_line_2'];
                    }

                    if(data.data['locality']) {
                        this.shipping['address_locality'] = data.data['locality'];
                    }
                    else {
                        delete this.shipping['address_locality'];
                    }

                    if(data.data['subdivision']) {
                        this.shipping['address_subdivision'] = data.data['subdivision'];
                    }
                    else {
                        delete this.shipping['address_subdivision'];
                    }

                    if(data.data['postal_code']) {
                        this.shipping['address_postal_code'] = data.data['postal_code'];
                    }
                    else {
                        delete this.shipping['address_postal_code'];
                    }

                    if(data.data['country_id']) {
                        this.shipping['address_country_id'] = data.data['country_id'];
                        this.loadCountry(data.data['country_id']).then(() => {
                            this.countryChanged();
                        })
                        .catch(() => { });
                    }
                    else {
                        delete this.shipping['address_country_id'];
                        delete this.shipping['address_line_1'];
                        delete this.shipping['address_line_2'];
                        delete this.shipping['address_locality'];
                        delete this.shipping['address_subdivision'];
                        delete this.shipping['address_postal_code'];
                        this.country = null;
                    }

                    if(data.data['mobile_phone_number']) {
                        this.shipping['address_mobile_phone_number'] = data.data['mobile_phone_number'];
                    }
                    else {

                        // NOTE: use the shipping address person mobile phone number
                        if(this.cart['person']) {
                            if(this.cart.person['mobile_phone_number']) {
                                this.shipping['address_mobile_phone_number'] = this.cart.person['mobile_phone_number'];
                            }
                            else {
                                delete this.shipping['address_mobile_phone_number'];
                            }
                        }
                        else {
                            delete this.shipping['address_mobile_phone_number'];
                        }

                    }

                    if(data.data['courier_instructions']) {
                        this.shipping['address_courier_instructions'] = data.data['courier_instructions'];
                    }
                    else {
                        delete this.shipping['address_courier_instructions'];
                    }

                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.shipping['delivery_date'] ? this.shipping['delivery_date'] : ""),
                    format: "date",
                    clear_date: true
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "date_deleted") {
                        this.shipping['delivery_date'] = "";
                        this.formatted_delivery_date = null;
                    }
                    else {
                        this.shipping['delivery_date'] = data.data['date'];
                        this.formatted_delivery_date = this.moment(this.shipping['delivery_date']).format("D MMM YYYY");
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentRemoveShippingConfirmation() {
        const alert = await this.alertController.create({
            header: 'Remove shipping',
            message: 'Are you sure you want to remove the shipping?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'OK',
                    handler: () => {
                        this.removeShipping();
                    }
                }
            ],
        });
        await alert.present();
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
